import React, {useEffect, useState} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';

import {
  Button,
  CapIcon,
  ChevronIcon,
  FileIcon,
  Heading,
  PeopleIcon,
  PipIcon,
  ProfileIcon,
  Text,
} from '@edume/magnificent';

import Container from '../../../components/ManagerInsights/Container';
import GlobalSearch from '../../../components/ManagerInsights/GlobalSearch';
import Header from '../../../components/ManagerInsights/Header';
import * as managerInsightsActions from '../../../state/managerInsights/managerInsightsActions';
import {getManagerInsightsByStore} from '../../../state/managerInsights/managerInsightsSelector';
import {formatedDateString} from '../../../utils/managerInsightUtils';

import managerInsightsStyles from '../styles.module.scss';
import styles from './styles.module.scss';

const mapStateToProps = (state, ownProps) => {
  const {insightId, managerId} = ownProps.match.params;
  const managerInsightsByStore = getManagerInsightsByStore(state);

  return {
    insightId,
    managerId,
    details: state.managerInsights.getIn(['insights', 'details']).toJS(),
    summary: managerInsightsByStore.get('summary').toJS(),
    users: managerInsightsByStore.get('users').toJS(),
    contents: managerInsightsByStore.get('contents').toJS(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(managerInsightsActions, dispatch),
});

const HomeView = ({
  insightId,
  managerId,
  summary,
  details,
  goToManagerInsightsTeamPerformance,
  goToManagerInsightsAssignedTraining,
  goToManagerInsightsContentDetail,
  goToManagerInsightsUserDetail,
  users,
  contents,
}) => {
  const {
    teamPerformance,
    assignedTraining,
    totalUserCount,
    notActivatedUserCount,
  } = summary;

  const [keyword, setKeyword] = useState('');
  const [searchMode, setSearchMode] = useState(false);

  useEffect(() => {
    if (!searchMode) {
      setKeyword('');
    }
  }, [searchMode]);

  return (
    <>
      <div className={managerInsightsStyles.view}>
        <div className={managerInsightsStyles.content}>
          <Header
            title={'Manager Insights'}
            search={true}
            value={keyword}
            onChange={setKeyword}
            onModeChange={setSearchMode}
            isModeSearch={searchMode}
          />

          <Container>
            {searchMode ? (
              <GlobalSearch
                keyword={keyword}
                totalUserCount={totalUserCount}
                users={users}
                contents={contents}
                insightId={insightId}
                managerId={managerId}
                goToManagerInsightsContentDetail={
                  goToManagerInsightsContentDetail
                }
                goToManagerInsightsUserDetail={goToManagerInsightsUserDetail}
              />
            ) : (
              <>
                <div styleName='introduction'>
                  <div styleName='primary-line'>
                    <Heading
                      as='h2'
                      colour='textPrimary'
                      size='leopard'
                      textTransform='none'
                      weight='semiBold'
                    >
                      Hi {details.managerName},
                    </Heading>
                    <Text
                      colour='grey700'
                      inline
                      lineHeight='tight'
                      size='l'
                      textTransform='none'
                      weight='regular'
                    >
                      {formatedDateString(details.date)}
                    </Text>
                  </div>
                  <div styleName='secondary-line'>
                    <Heading
                      as='h2'
                      colour='textPrimary'
                      size='leopard'
                      textTransform='none'
                      weight='semiBold'
                    >
                      Here are the weekly training updates for{' '}
                      <span>{details.teamName}</span>
                    </Heading>
                  </div>
                </div>
                <div styleName='overview-wrapper'>
                  <div
                    styleName='overview'
                    data-automation='team-performance-block'
                  >
                    <div styleName='overview-title'>
                      <PeopleIcon size='big' />
                      <Heading
                        as='h3'
                        colour='textPrimary'
                        size='sheep'
                        textTransform='none'
                        weight='semiBold'
                      >
                        Team performance
                      </Heading>
                    </div>

                    <ul styleName='overview-list'>
                      {!!notActivatedUserCount && (
                        <li>
                          <PipIcon colour='brandPrimary' size='tiny' />
                          <Text
                            colour='grey700'
                            inline
                            lineHeight='tight'
                            size='m'
                            textTransform='none'
                            weight='regular'
                          >
                            <strong>{notActivatedUserCount} people</strong> are
                            <strong> not activated</strong>
                          </Text>
                        </li>
                      )}
                      <li>
                        <PipIcon colour='brandPrimary' size='tiny' />
                        <Text
                          colour='grey700'
                          inline
                          lineHeight='tight'
                          size='m'
                          textTransform='none'
                          weight='regular'
                        >
                          <strong>
                            {teamPerformance.hundred} of {totalUserCount} people
                          </strong>{' '}
                          completed <strong>100%</strong>
                        </Text>
                      </li>
                      <li>
                        <PipIcon colour='brandPrimary' size='tiny' />
                        <Text
                          colour='grey700'
                          inline
                          lineHeight='tight'
                          size='m'
                          textTransform='none'
                          weight='regular'
                        >
                          <strong>
                            {teamPerformance.moreThanEighty} of {totalUserCount}{' '}
                            people
                          </strong>{' '}
                          completed more than <strong>80%</strong>
                        </Text>
                      </li>
                      <li>
                        <PipIcon colour='brandPrimary' size='tiny' />
                        <Text
                          colour='grey700'
                          inline
                          lineHeight='tight'
                          size='m'
                          textTransform='none'
                          weight='regular'
                        >
                          <strong>
                            {teamPerformance.lessThanFifty.count} of{' '}
                            {totalUserCount} people
                          </strong>{' '}
                          completed less than <strong>50%</strong>
                        </Text>
                      </li>
                    </ul>
                    <ul styleName='team-list'>
                      {teamPerformance.lessThanFifty.users.map(
                        (fullName, index) => (
                          <li key={index}>
                            <ProfileIcon colour={'grey700'} size='xsmall' />
                            <Text
                              colour='grey700'
                              inline
                              lineHeight='tight'
                              size='s'
                              textTransform='none'
                              weight='medium'
                            >
                              {fullName}
                            </Text>
                          </li>
                        )
                      )}
                      {teamPerformance.lessThanFifty.count -
                        teamPerformance.lessThanFifty.users.length >
                        0 && (
                        <li>
                          <Text
                            colour='grey700'
                            inline
                            lineHeight='tight'
                            size='s'
                            textTransform='none'
                            weight='medium'
                          >
                            {teamPerformance.lessThanFifty.count -
                              teamPerformance.lessThanFifty.users.length}
                            + more
                          </Text>
                        </li>
                      )}
                    </ul>
                    <Button
                      bold
                      buttonText='See all'
                      fullWidth
                      icon={<ChevronIcon orientation='right' />}
                      iconPosition='end'
                      innerContent='text'
                      isCursorAllowed
                      onClick={() =>
                        goToManagerInsightsTeamPerformance({
                          insightId,
                          managerId,
                        })
                      }
                      reskinClassName=''
                      type='primary'
                    >
                      See all
                    </Button>
                  </div>

                  <div styleName='overview'>
                    <div styleName='overview-title'>
                      <CapIcon size='big' />
                      <Heading
                        as='h3'
                        colour='textPrimary'
                        size='sheep'
                        textTransform='none'
                        weight='semiBold'
                      >
                        Assigned training
                      </Heading>
                    </div>

                    <ul styleName='overview-list'>
                      <li>
                        <PipIcon colour='brandPrimary' size='tiny' />
                        <Text
                          colour='grey700'
                          inline
                          lineHeight='tight'
                          size='m'
                          textTransform='none'
                          weight='regular'
                        >
                          <strong>
                            {assignedTraining.newContentCount} new trainings
                          </strong>{' '}
                          assigned in the <strong>last 30 days</strong>
                        </Text>
                      </li>
                      <li>
                        <PipIcon colour='brandPrimary' size='tiny' />
                        <Text
                          colour='grey700'
                          inline
                          lineHeight='tight'
                          size='m'
                          textTransform='none'
                          weight='regular'
                        >
                          <strong>
                            {assignedTraining.newContentCompleterCount} of{' '}
                            {totalUserCount} people
                          </strong>{' '}
                          have completed new training
                        </Text>
                      </li>
                      <li>
                        <PipIcon colour='brandPrimary' size='tiny' />
                        <Text
                          colour='grey700'
                          inline
                          lineHeight='tight'
                          size='m'
                          textTransform='none'
                          weight='regular'
                        >
                          <strong>
                            {assignedTraining.lessThanFifty.count}{' '}
                            {assignedTraining.lessThanFifty.count > 1
                              ? 'trainings'
                              : 'training'}
                          </strong>{' '}
                          completed by{' '}
                          <strong>
                            less than {(totalUserCount / 2).toFixed()} people
                          </strong>
                        </Text>
                      </li>
                    </ul>
                    <ul styleName='team-list'>
                      {assignedTraining.lessThanFifty.contents.map(
                        (title, index) => (
                          <li key={index}>
                            <FileIcon colour={'grey700'} size='tiny' />
                            <Text
                              colour='grey700'
                              inline
                              lineHeight='tight'
                              size='s'
                              textTransform='none'
                              weight='medium'
                            >
                              {title}
                            </Text>
                          </li>
                        )
                      )}
                    </ul>
                    <Button
                      bold
                      buttonText='See all'
                      fullWidth
                      icon={<ChevronIcon orientation='right' />}
                      iconPosition='end'
                      innerContent='text'
                      isCursorAllowed
                      onClick={() =>
                        goToManagerInsightsAssignedTraining({
                          insightId,
                          managerId,
                        })
                      }
                      reskinClassName=''
                      type='primary'
                    >
                      See all
                    </Button>
                  </div>
                </div>
              </>
            )}
          </Container>
        </div>
      </div>
    </>
  );
};

HomeView.propTypes = {
  insightId: PropTypes.string.isRequired,
  managerId: PropTypes.string.isRequired,
  details: PropTypes.object.isRequired,
  summary: PropTypes.object.isRequired,
  contents: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  goToManagerInsightsTeamPerformance: PropTypes.func.isRequired,
  goToManagerInsightsAssignedTraining: PropTypes.func.isRequired,
  goToManagerInsightsContentDetail: PropTypes.func.isRequired,
  goToManagerInsightsUserDetail: PropTypes.func.isRequired,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(CSSModules(HomeView, styles, {allowMultiple: true})))
);
